import { useLocation, useNavigate } from 'react-router-dom';

const navItems = [
  { path: '/', icon: 'ri-home-5-line', activeIcon: 'ri-home-5-fill', label: '首页' },
  { path: '/focus', icon: 'ri-timer-line', activeIcon: 'ri-timer-fill', label: '专注' },
  { path: '/habit', icon: 'ri-checkbox-circle-line', activeIcon: 'ri-checkbox-circle-fill', label: '习惯' },
  { path: '/profile', icon: 'ri-user-3-line', activeIcon: 'ri-user-3-fill', label: '我的' },
];

export default function BottomNav() {
  const location = useLocation();
  const navigate = useNavigate();

  return (
    <nav
      className="absolute bottom-0 left-0 right-0 z-50 flex items-center justify-around"
      style={{
        height: 80,
        paddingBottom: 16,
        paddingLeft: 16,
        paddingRight: 16,
        background: 'rgba(255,255,255,0.88)',
        backdropFilter: 'blur(16px)',
        WebkitBackdropFilter: 'blur(16px)',
        borderTop: '1px solid rgba(181,198,224,0.2)',
        borderRadius: '24px 24px 40px 40px',
      }}
    >
      {navItems.map(item => {
        const isActive = location.pathname === item.path;
        return (
          <button
            key={item.path}
            onClick={() => navigate(item.path)}
            className="flex flex-col items-center justify-center gap-0.5 cursor-pointer transition-all active:scale-90"
            style={{ minWidth: 60 }}
          >
            <div className="w-6 h-6 flex items-center justify-center">
              <i
                className={`${isActive ? item.activeIcon : item.icon} text-xl`}
                style={{ color: isActive ? '#8B9DC3' : '#B0B0B0' }}
              />
            </div>
            <span
              style={{
                fontSize: 11,
                color: isActive ? '#8B9DC3' : '#B0B0B0',
                fontWeight: isActive ? 600 : 400,
              }}
            >
              {item.label}
            </span>
          </button>
        );
      })}
    </nav>
  );
}
